'use client'

import { RefObject, useEffect } from 'react'

export function useDocumentEventOutside<
  DocumentEventKey extends keyof DocumentEventMap,
  ElementType extends Element,
>(
  eventKey: DocumentEventKey,
  containerRef: RefObject<ElementType>,
  listener: (event: DocumentEventMap[DocumentEventKey]) => unknown
) {
  useEffect(() => {
    function listenerAdapater(event: DocumentEventMap[DocumentEventKey]) {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        listener(event)
      }
    }
    document.addEventListener(eventKey, listenerAdapater)
    return () => document.removeEventListener(eventKey, listenerAdapater)
  }, [eventKey, containerRef, listener])
}
